import EnglishLanguage from "./entries/en_US"
import SpanishLanguage from './entries/es_ES'

const Translations = {
  en: EnglishLanguage,
  es: SpanishLanguage,
}

export default Translations
